import { clientPortalRequest, buildClientQuery } from "./clientPortalFetch";

const base = (clientViewId) => `/views/${clientViewId}/servicios`;

export function listVerificationCases(clientViewId, params = {}) {
  return clientPortalRequest(`${base(clientViewId)}/verificacion${buildClientQuery(params)}`);
}

export function getVerificationCase(clientViewId, caseId) {
  return clientPortalRequest(`${base(clientViewId)}/verificacion/${caseId}`);
}

export function createVerificationCase(clientViewId, body) {
  return clientPortalRequest(`${base(clientViewId)}/verificacion`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function transitionVerificationCase(clientViewId, caseId, body) {
  return clientPortalRequest(`${base(clientViewId)}/verificacion/${caseId}/transicion`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function assignVerificationCase(clientViewId, caseId, body) {
  return clientPortalRequest(`${base(clientViewId)}/verificacion/${caseId}/asignar`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function recordVerificationCheck(clientViewId, caseId, checkId, body) {
  return clientPortalRequest(`${base(clientViewId)}/verificacion/${caseId}/checks/${checkId}`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function previewVerificationDecision(clientViewId, caseId, body = {}) {
  return clientPortalRequest(`${base(clientViewId)}/verificacion/${caseId}/preview`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function completeVerificationCase(clientViewId, caseId, body = {}) {
  return clientPortalRequest(`${base(clientViewId)}/verificacion/${caseId}/completar`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function addVerificationContactAttempt(clientViewId, caseId, body) {
  return clientPortalRequest(`${base(clientViewId)}/verificacion/${caseId}/contacto`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function createReverificationCase(clientViewId, caseId, body = {}) {
  return clientPortalRequest(`${base(clientViewId)}/verificacion/${caseId}/reverificacion`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function getVendorVerificationPanel(clientViewId, vendorId) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores/${vendorId}/verificacion`);
}

export function listCredentialsQueue(clientViewId, params = {}) {
  return clientPortalRequest(`${base(clientViewId)}/credenciales${buildClientQuery(params)}`);
}

export function getCredentialDetail(clientViewId, credentialId) {
  return clientPortalRequest(`${base(clientViewId)}/credenciales/${credentialId}`);
}

export function createCredential(clientViewId, body) {
  return clientPortalRequest(`${base(clientViewId)}/credenciales`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function submitCredentialForReview(clientViewId, credentialId) {
  return clientPortalRequest(`${base(clientViewId)}/credenciales/${credentialId}/enviar`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export function verifyCredential(clientViewId, credentialId, body = {}) {
  return clientPortalRequest(`${base(clientViewId)}/credenciales/${credentialId}/verificar`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function rejectCredential(clientViewId, credentialId, body) {
  return clientPortalRequest(`${base(clientViewId)}/credenciales/${credentialId}/rechazar`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function revokeCredential(clientViewId, credentialId, body) {
  return clientPortalRequest(`${base(clientViewId)}/credenciales/${credentialId}/revocar`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function supersedeCredential(clientViewId, credentialId, body) {
  return clientPortalRequest(`${base(clientViewId)}/credenciales/${credentialId}/sustituir`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function listExpiringVerificationBadges(clientViewId, params = {}) {
  return clientPortalRequest(
    `${base(clientViewId)}/verificacion/insignias-por-vencer${buildClientQuery(params)}`
  );
}

export async function uploadVerificationEvidence(clientViewId, formData) {
  const response = await fetch(`/api/client${base(clientViewId)}/evidencia`, {
    method: "POST",
    credentials: "include",
    body: formData,
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(body.error || "Evidence upload failed.");
  }
  return body;
}

export function getEvidenceDownloadUrl(clientViewId, evidenceId) {
  return `/api/client${base(clientViewId)}/evidencia/${evidenceId}/descargar`;
}
